import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { ApiResponse } from '../models/ApiResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  async GetExpiringPolicies(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetExpiringPolicies`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });
  }
  
  async GetLeadsStatusCustomerDashboard(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetLeadsStatusCustomerDashboard`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });
  }

  async GetCustomerLeadsCardDashboard(data:any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetCustomerLeadsCardDashboard`,data,  {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });
  }

    async GetTop5DistDashboardData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetTop5DistDashboardData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async GetTop5ResDashboardData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetTop5ResDashboardData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async GetAminDashboardData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetAminDashboardData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async GetAminDashboardDistributorData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetAminDashboardDistributorData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async PolicySoldLineChartData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/PolicySoldLineChartData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async DashboardAgentTop5Performance(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/DashboardAgentTop5Performance`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async GetTop5DistributorDashboardData(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetTop5DistributorDashboardData`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async DashboardDistributorStatus(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/DashboardDistributorStatus`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  async DashboardResellerStatus(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/DashboardResellerStatus`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async DashboardAgentStatus(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/DashboardAgentStatus`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async GetLeadsStatus(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}dashboard/GetLeadsStatusDashboard`,data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
}
